























import SharedState from '@/data/SharedState';
import { computed, defineComponent, onMounted, onUpdated, ref, watch } from '@vue/composition-api';

export default defineComponent({

  props: {
    text: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {

    const showAll = ref(false);
    const paragraph = ref<Element|null>(null);
    const textIsOverflowing = ref(false);
    let textChanged = false;

    const buttonText = computed(() => {
      return showAll.value
        ? SharedState.getText(context, 'corptube.read.less') 
        : SharedState.getText(context, 'corptube.read.more');
    });

    const maxHeight = computed(() => {
      return showAll.value === true ? 'auto' : '3em';
    });

    const isOverflowing = () => {
      if(paragraph.value === null) return false;
      return paragraph.value.clientHeight < paragraph.value.scrollHeight;
    };

    const buttonClicked = () => {
      showAll.value = !showAll.value;
    };

    watch(() => props.text,
    () => {
      showAll.value = false;
      textChanged = true;
    });

    onUpdated(() => {
      if(textChanged) {
        textIsOverflowing.value = isOverflowing();
        textChanged = false;
      }
    });

    onMounted(() => {
      textIsOverflowing.value = isOverflowing();
    });

    return {
      buttonText,
      showAll,
      textIsOverflowing,
      paragraph,
      maxHeight,
      buttonClicked
    }
  }
});

